import { CanActivateFn } from '@angular/router'
import { environment } from '@env/environment'

export const productionGuard: CanActivateFn = (route, state) => {
    if (environment.marketingHomeUrlShort !== 'focusmate.com') {
        return true
    } else {
        return false
    }
}
